import { RowCrudStatus } from "../../common/types";
import { SatelliteTask } from "../../../api/graphql";
import { LangStore } from "../../../store";

export type SatelliteTaskValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
};

export type SatelliteTaskErrorsType = {};

export function SatelliteTaskValuesInit(): SatelliteTaskValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
  };
}

export type SatelliteTaskType = SatelliteTask | SatelliteTaskValuesType;

export function satelliteTaskDisplayId(
  source: Partial<SatelliteTask>,
  _langStore: LangStore
) {
  return (
    (source.taskType ?? _langStore.emptyStringSymbol) +
    "-" +
    (source.correlationId ?? _langStore.emptyStringSymbol)
  );
}

export function getSatelliteTaskValues(
  source: SatelliteTaskType,
  _langStore: LangStore,
  _duplicated: boolean = false
): SatelliteTaskValuesType {
  const entityValues = SatelliteTaskValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : satelliteTaskDisplayId(source, _langStore);
  entityValues.version_ = source.version_;

  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
